// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1N974","footer":"ModalUpdate_footer__2mu9r"};